<template>
  <div class="user-changePwd-view">
    <section class="module">
      <header class="m-header clear-f">
        <span class="m-title">修改密码</span>
      </header>
      <div class="m-body">
        <el-form ref="form" :model="model" status-icon :rules="rules" label-width="120px" label-position="left">
          <el-form-item label="原密码：" prop="orgPwd">
            <el-input v-model="model.orgPwd" placeholder="请输入原密码" auto-complete="off" :maxlength="30" type="password">
              <i slot="prefix" class="iconfont icon-lock"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="新密码：" prop="newPwd">
            <el-input v-model="model.newPwd" @keyup.enter.native="submit" placeholder="请输入新密码" auto-complete="off" :maxlength="30" type="password">
              <i slot="prefix" class="iconfont icon-lock"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="确认新密码：" prop="repeat">
            <el-input v-model="model.repeat" @keyup.enter.native="submit" placeholder="请确认新密码" auto-complete="off" :maxlength="30" type="password">
              <i slot="prefix" class="iconfont icon-lock"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" :loading="loading" @click="submit">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'changePassword',
  data () {
    let checkPassword = (rule, value, callback) => {
      if (value) {
        if (value.length < 6) {
          callback(new Error('密码最少6位'))
          return
        } else if (this.model.repeat) {
          this.$refs.form.validateField('repeat')
        }
      }
      callback()
    }
    let checkPassword2 = (rule, value, callback) => {
      if (value) {
        if (value !== this.model.newPwd) {
          callback(new Error('两次输入密码不一致'))
          return
        }
      }
      callback()
    }
    return {
      loading: false,
      model: {
        orgPwd: '',
        newPwd: '',
        repeat: ''
      },
      rules: {
        orgPwd: [{ required: true, message: '请输入原密码', trigger: 'change' }],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'change' },
          { validator: checkPassword, trigger: 'blur' }
        ],
        repeat: [
          { required: true, message: '请确认新密码', trigger: 'change' },
          { validator: checkPassword2, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.$store.dispatch('setNavigation', [{ name: '个人中心', path: '/user/center' }, { name: '修改密码' }])
  },
  methods: {
    submit () {
      // 防止重复提交登录信息
      if (this.logining) {
        return false
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.logining = true
          // 调用api修改密码接口
          this.$http.post('user/chgpwd', this.model)
            .then((response) => {
              this.logining = false
              this.$message.success('密码修改成功')
              this.$store.dispatch('invalidAuthentication')
            })
            .catch((error) => {
              this.logining = false
              this.$message.error(error && error.msg ? error.msg : '密码修改失败')
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss">
.user-changePwd-view {
  .el-form {
    width: 500px;
    margin: 0 auto;
  }
  .el-input__prefix {
    left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/changePwd.vue